import {
  Badge,
  Card,
  Container,
  SimpleGrid,
  Stack,
  Text,
  ThemeIcon,
  Title,
} from '@mantine/core';
import { Activity, Image, Utensils } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import PageHeader from '@components/shared/PageHeader';

const APPS = [
  {
    id: 'exposure',
    title: 'Exposure',
    description:
      'Avvia una sessione e verifica tutorial, shown/feedback, start/end e cancel.',
    to: '/admin/app-playground/exposure',
    icon: Utensils,
    color: 'teal',
    ready: true,
  },
  {
    id: 'performance',
    title: 'Performance',
    description: 'Playground eventi Ably per sessioni performance.',
    to: '/admin/app-playground/performance',
    icon: Activity,
    color: 'blue',
    ready: false,
  },
  {
    id: 'body-image',
    title: 'Body image',
    description:
      'Avvia con start_bodyimage e verifica tutti gli eventi hub→device.',
    to: '/admin/app-playground/body-image',
    icon: Image,
    color: 'violet',
    ready: true,
  },
] as const;

export default function AppPlaygroundHub() {
  const navigate = useNavigate();

  return (
    <Container size='xl' py='lg'>
      <Stack gap='lg'>
        <PageHeader
          title='App Playground testing'
          breadcrumbs={[
            { label: 'Admin', href: '/admin' },
            { label: 'App Playground testing' },
          ]}
          showBackButton={false}
        />
        <Text c='dimmed'>
          Test degli eventi Ably per le app della piattaforma. Per ora è attivo
          solo Exposure.
        </Text>
        <SimpleGrid cols={{ base: 1, md: 2, xl: 3 }}>
          {APPS.map(app => (
            <Card
              key={app.id}
              withBorder
              shadow='sm'
              padding='lg'
              radius='md'
              style={{ cursor: 'pointer' }}
              onClick={() => navigate(app.to)}
            >
              <Stack gap='md'>
                <ThemeIcon
                  size={54}
                  radius='md'
                  variant='light'
                  color={app.color}
                >
                  <app.icon size={28} />
                </ThemeIcon>
                <div>
                  <Title order={4}>{app.title}</Title>
                  {!app.ready && (
                    <Badge mt='xs' variant='light' color='gray'>
                      Prossimamente
                    </Badge>
                  )}
                  <Text size='sm' c='dimmed' mt='xs'>
                    {app.description}
                  </Text>
                </div>
              </Stack>
            </Card>
          ))}
        </SimpleGrid>
      </Stack>
    </Container>
  );
}
